// Shared process-construct vocabulary for the WYSIWYG edit affordances (the
// StepEditMenu "wrap in" chips + the ContextPad quick-wrap). Lives outside any
// component file so both can import it without a Fast-Refresh incompatible
// export (a const exported from a .tsx forces a full reload).

import type { WrapConstruct } from "./processStepEdit.js";

/** The control constructs a step (or contiguous run) can be wrapped into. */
export const WRAP_CONSTRUCTS: readonly WrapConstruct[] = ["if", "each", "try", "parallel", "reversible"];
